import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTheme } from 'styled-components';
import Lottie from 'lottie-react';
import { screenSizes } from '@libs/theme';
import { useDimensions } from '@libs/hooks';
import { DECIMAL_PRECISION_STABLE_COIN } from '@libs/backend-common';
import { CurrencyInputLoader } from '../content-loaders';
import { loadingAnimation } from '../animations';
import Typography from '../typography/Typography';
import { CURRENCY_INPUT_MAX_LENGTH } from '../constants';
import Tabs from '../tabs/Tabs';
import { AnimationWrapper, CustomBalanceContainer, CustomCurrencyContainer, CustomInputTab, CustomErrorMessage, CustomInput, CustomSelectContainer, CustomTransparentButton, FlexContainer, TabsWrapper, } from './styles';
export const UNSTABLE_CURRENCY_INPUT_DECIMAL_PRECISION = 7;
export const InputTab = ({ borderBottomFlat, borderTopFlat, onBtnClick, buttonTitle, errorMessage, description, tabOptionList, descLoaded, onFocus, activeTab, setActiveTab, onBlur, className, name, roundingPrecision, icon, ...props }) => {
    const [isFocused, setFocused] = useState();
    const { colors } = useTheme();
    const handleInputFocusState = (e) => {
        setFocused(true);
        onFocus?.(e);
    };
    const handleInputOnBlur = (e) => {
        setFocused(false);
        onBlur?.(e);
    };
    const handleClick = (e) => {
        if (!onBtnClick)
            return;
        onBtnClick(e);
    };
    const handleChange = (e) => {
        let newValue = e.target.value.replace(',', '.');
        if (newValue.length === 1 && newValue === '.') {
            newValue = '0.';
        }
        if (props.inputValue.length > newValue.length && newValue === '0.') {
            newValue = '0';
        }
        if (isNaN(+newValue) ||
            newValue.match(/^0[0-9]/) ||
            newValue.match(/[\s-+]/)) {
            return;
        }
        const currentDecimalsCount = newValue.split('.')[1]?.length;
        const defaultRoundingPrecision = props.isUnstable
            ? UNSTABLE_CURRENCY_INPUT_DECIMAL_PRECISION
            : DECIMAL_PRECISION_STABLE_COIN;
        const maxDecimals = roundingPrecision || defaultRoundingPrecision;
        if (currentDecimalsCount > maxDecimals) {
            return;
        }
        props.inputOnChange?.({
            ...e,
            target: {
                ...e.target,
                name,
                value: newValue,
            },
        });
    };
    const loading = !(typeof descLoaded === 'boolean' ? descLoaded : true);
    const { width } = useDimensions();
    const pattern = width < screenSizes.laptop ? 'd*' : undefined;
    return (_jsxs(CustomCurrencyContainer, { className: className, children: [_jsxs(CustomInputTab, { isFocused: props.isLoading || isFocused, hasError: !!errorMessage, borderTopFlat: borderTopFlat, borderBottomFlat: borderBottomFlat, "data-testid": "CustomInputTab", children: [_jsx(CustomInput, { loading: !!props.isLoading, inputMode: 'decimal', type: "text", name: name, pattern: pattern, maxLength: CURRENCY_INPUT_MAX_LENGTH, onBlur: handleInputOnBlur, onFocus: handleInputFocusState, value: props.inputValue, placeholder: props.inputPlaceHolder, title: props.title, onChange: handleChange, onWheel: (e) => e.target.blur(), isLoading: props.isLoading, onChangeText: props.onChangeText, icon: icon }), props.isLoading && (_jsx(AnimationWrapper, { children: _jsx(Lottie, { loop: true, animationData: loadingAnimation }) })), loading ? (_jsx(CurrencyInputLoader, { hasButton: !!buttonTitle, hasDesc: typeof descLoaded === 'boolean' })) : (_jsxs(CustomSelectContainer, { children: [_jsxs(FlexContainer, { children: [buttonTitle && (_jsx(CustomTransparentButton, { onClick: handleClick, children: _jsx(Typography, { type: "caption", fontFamily: "primaryBold", color: colors.interactive.brandColor, children: buttonTitle }) })), _jsx(TabsWrapper, { children: _jsx(Tabs, { activeTab: activeTab, tabs: tabOptionList, handleTabClick: setActiveTab }) })] }), _jsx(CustomBalanceContainer, { children: description && (_jsx(Typography, { type: "caption", fontFamily: "primaryRegular", color: colors.text.default, lineHeight: 1.4, testId: `currency_input_description`, children: description })) })] }))] }), _jsx(CustomErrorMessage, { errorMessage: errorMessage, className: "error-message" })] }));
};
export default InputTab;
//# sourceMappingURL=InputTab.js.map